export const UPLOAD_FETCH_INTERVAL = 2000;
